import { Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "../../../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-zone-delete-confirm-dialog",
  templateUrl: "./zone-delete-confirm-dialog.component.html",
  styleUrls: ["./zone-delete-confirm-dialog.component.css"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    DialogHeaderComponent
  ]
})
export class ZoneDeleteConfirmDialogComponent {
  dialogRef =
    inject<MatDialogRef<ZoneDeleteConfirmDialogComponent>>(MatDialogRef);
  data = inject<{}>(MAT_DIALOG_DATA);

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
